/**
 * The key the API requires on every /api call in production.
 * @file src/web/shared/frontendKey.ts
 *
 * The server refuses an /api request without it once NODE_ENV=production (the
 * frontend key block in src/api/server.ts) and skips the check everywhere else -
 * which is why a call that forgets it works in development and fails only on a
 * deployed site. Vite inlines the value at build time.
 */
export const FRONTEND_KEY_HEADER = 'X-Frontend-Key';

/** The header to spread into any request to this app's API; empty when no key is configured. */
export function frontendKeyHeader(): Record<string, string> {
  const key = import.meta.env.VITE_FRONTEND_KEY;
  return key ? { [FRONTEND_KEY_HEADER]: key } : {};
}
